import { useEffect, useState } from "react";
import api from "../../services/api";
import sal from "sal.js";
import "sal.js/dist/sal.css";

const Footer = () => {
  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    api.get("api/global/footer")
      .then(res => {
        if (res.data.status) {
          setWidgets(res.data.data);
        }
      })
      .catch(err => {
        console.error("Footer API error:", err);
      });
  }, []);

  useEffect(() => {
    sal({
      threshold: 0.1,
      once: false,
      disabled: false 
    });
  }, []);


  useEffect(() => {
    if (!widgets.length) return;

    setTimeout(() => {
      document.querySelectorAll(".footer-list").forEach(list => {
        let delay = 50;
        list.querySelectorAll("li").forEach(li => {
          li.setAttribute("data-sal", "slide-up");
          li.setAttribute("data-sal-duration", "1000");
          li.setAttribute("data-sal-delay", delay);
          delay += 50;
        });
      });

      sal(); 
    }, 100);
  }, [widgets]);

  const rowColsClass = widgets.length <= 4
    ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"
    : widgets.length === 5
      ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5"
      : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6";

  const isCondensed = widgets.length >= 5;

  return (
    <section className={`footer-section ${isCondensed ? "footer-condensed" : ""}`}>
      <div className="container">
        <div className={`row ${rowColsClass} g-4`}>

          {widgets.map((widget, wIndex) => (
            <div className="col" key={widget.id || wIndex}>
              <ul className="footer-list">
                <h3>{widget.title}</h3>

                {widget.items.map((item, i) => (
                  item.type === "heading" ? (
                    <li
                      key={i}
                      style={{
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        color: "white"
                      }}
                    >
                      {item.title}
                    </li>
                  ) : (
                    <li key={i}>
                      <a href={item.url}>{item.title}</a>
                    </li>
                  )
                ))}
              </ul>
            </div>
          ))}

        </div>

        <div className="footer-bottom mt-4">
          <p className="copyright">
            Copyright © {new Date().getFullYear()} Lifeline Group of Hospitals Private Limited.
            All Rights Reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
